import React from "react";
import BrandFive from "./BrandFive";
import Video from "./Video";
import { WEBAPP_URL } from "../urls";
const heroContent = {
  title: "Land your dream job perfecting interviews with AI.",
  description: `Your Secret Weapon for Job Interview Success.`,
  buttonText: " Try for Free",
};

const HeroBannerEight = () => {
  return (
    <div className="hero-banner-eight">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 m-auto">
            <h1 className="hero-heading" data-aos="fade-up">
              {heroContent.title}
            </h1>
            <p
              className="hero-sub-heading"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              {heroContent.description}
            </p>
            <a
              href={WEBAPP_URL}
              className="theme-btn-cta-hero"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {heroContent.buttonText}
            </a>
          </div>
        </div>

        <div className="video-wrapper">
          <Video />
        </div>
        {/* /.video-wrapper */}
      </div>
{/*
      <div className="partner-slider-two mt-130 md-mt-80">
        <div className="container">
          <div className="partnerSliderTwo">
            <BrandFive />
          </div>
        </div>
      </div> /*}
      {/* /.partner-slider-two */}
      {/*
      <img
        src="ffflux.svg"
        alt="shape"
        className="shapes shape-right"
      />
      <img
        src="images/shape/mitras_custom2.svg"
        alt="shape"
        className="shapes shape-right"
      />
      <img
        src="images/shape/mitras_cusom2.svg"
        alt="shape"
        className="shapes shape-right"
      />
            <img
        src="images/shape/graphic_bg.svg"
        alt="shape"
        className="shapes shape-right"
      />
  */}
      <img
        src="images/shape/mitras_custom4.svg"
        alt="shape"
        className="shapes shape-left"
      />
      {/*}
      <img
        src="images/shape/173.svg"
        alt="shape"
        className="shapes shape-right"
      />
      <img
        src="images/shape/174.svg"
        alt="shape"
        className="shapes shape-left"
      />
  */}
    </div>
    //   /.hero-banner-eight
  );
};

export default HeroBannerEight;
